import React, { useContext, useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'

import Context from '../../context'
import { getCategoriesList, getListTags, getPartnerById } from '../../services/ClubeApi'
import ProgressBar from '../ProgressBar'

function SelectTags({ categoryType }) {
  const { tags, setTags, formObject, setFormObject } = useContext(Context)
  const [tagList, setTagList] = useState([])
  const [categoryList, setCategoryList] = useState([])
  const [tagLoading, setTagLoading] = useState(true)

  const [mainTag, setMainTag] = useState({
    id: 0,
    name: '',
    slug: '',
    main: 1
  })

  useEffect(() => {
    const getTags = async () => {
      return getListTags()
    }

    const getCategories = async () => {
      return getCategoriesList(categoryType)
    }

    if (tagList.length === 0) {
      getTags().then(r => {
        setTagList(
          r
            .map(item => {
              return {
                ...item,
                placeholder: `${item.TagsTop.description} | ${item.name}`
              }
            })
            .sort((a, b) => (a.placeholder < b.placeholder ? -1 : 1))
        )
        setTagLoading(false)
      })
    }

    if (categoryList.length === 0) {
      getCategories().then(r => {
        setCategoryList(
          r
            .map(item => {
              return {
                ...item,
                placeholder: `${item.TagsTop.description} | ${item.name}`
              }
            })
            .sort((a, b) => (a.placeholder < b.placeholder ? -1 : 1))
        )
      })

      setTagLoading(false)
    }
  }, [])

  const tagChecked = id => {
    const newArr = [...tags]
    // console.log(newArr);
    return newArr.includes(id)
  }

  const handleCheck = id => {
    const newArr = [...tags]
    console.log('tags vindas', tags)
    if (tags.includes(id)) {
      const i = newArr.indexOf(id)
      if (i > -1) newArr.splice(i)
    } else {
      newArr.push(id)
    }

    setTags([...newArr])
  }

  const defaultProps = {
    options: categoryList,
    getOptionLabel: option => option.placeholder
  }

  useEffect(() => {
    if (formObject && formObject.mainTag) {
      setMainTag(categoryList.find(item => item.id === formObject.mainTag))
    }
  }, [categoryList])

  useEffect(() => {
    if (mainTag) {
      if (mainTag.id !== 0 && mainTag.id !== formObject.mainTag) {
        setFormObject(data => {
          return { ...data, mainTag: mainTag.id }
        })
      }
    }
  }, [mainTag])
  // teste
  useEffect(() => {
    if (formObject && formObject.id) {
      getPartnerById(formObject.id).then(r => {
        if (r) {
          const { partnerTags } = r

          if (partnerTags) {
            const searchedTags = partnerTags.map(tag => {
              return tag.tagsId
            })
            if (tags.length === 0) {
              setTags(searchedTags)
            }
          }
        }
      })
    }
  }, [])

  return (
    <>
      <div className="col-12" style={{ marginBottom: '10px' }}>
        <Autocomplete
          {...defaultProps}
          id="selecMainTag"
          value={mainTag || { name: '' }}
          onChange={(event, newValue) => {
            setMainTag(newValue)
          }}
          renderInput={params => (
            <TextField {...params} label="Categoria" margin="normal" variant="outlined" fullWidth />
          )}
        />
      </div>
      <div className="col-12 clube-20-botom-margin">
        <div className="accordion" id="accordion">
          <div key="tag-accordion" className="card">
            <div className="card-header" id="heading-tags">
              <h5 className="col-12">
                <div
                  className="col item-click"
                  data-toggle="collapse"
                  data-target="#collapse-tags"
                  aria-expanded="true"
                  aria-controls="#collapse-tags"
                >
                  Selecione as Tags:
                </div>
              </h5>
            </div>
            <div
              id="collapse-tags"
              className="collapse show"
              aria-labelledby="heading-tags"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="row">
                  {tagLoading && (
                    <ProgressBar height="10px" width="100%" marginTop="10px" marginBottom="10px" />
                  )}
                  {tagList.length > 0 &&
                    tagList.map(item => (
                      <div key={item.id} className="form-group col-md-3">
                        <div className="form-check">
                          <input
                            id={`tag-${item.id}`}
                            className="form-check-input"
                            type="checkbox"
                            checked={tagChecked(item.id)}
                            onChange={() => handleCheck(item.id)}
                          />
                          <label htmlFor={`tag-${item.id}`} className="form-check-label">
                            {item.name}
                          </label>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

SelectTags.defaultProps = {
  categoryType: 'categoryPartners'
}

SelectTags.propTypes = {
  categoryType: PropTypes.string
}

export default SelectTags
